/* src/app/components/map/map.component.scss */
:root {
  --yf-border-radius: 12px;
  --yf-shadow: 5px 5px 10px #0000001f;
  --yf-spacing0: 6px;
  --yf-spacing1: 12px;
  --yf-spacing2: 24px;
  --yf-spacing3: 36px;
  --yf-spacing4: 48px;
  --yf-spacing5: 60px;
  --yf-primary-light: #9edaff;
  --yf-primary: #297eb2;
  --yf-primary-dark: #174c6d;
  --yf-secondary: #0d2c40;
  --yf-accent: #c2fc84;
  --yf-white: #FFFF;
}
.mapbox-map {
  --yf-android-navigation-bottom-space: 0px;
  --yf-system-bottom-safe-area: max( env(safe-area-inset-bottom), var(--ion-safe-area-bottom, 0px), var(--yf-android-navigation-bottom-space) );
  height: 100%;
  width: 100%;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl-bottom-left,
.mapbox-map ::ng-deep .mapboxgl-ctrl-bottom-right {
  bottom: calc(52px + var(--yf-system-bottom-safe-area) + 8px) !important;
  z-index: 1 !important;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl-bottom-left .mapboxgl-ctrl,
.mapbox-map ::ng-deep .mapboxgl-ctrl-bottom-right .mapboxgl-ctrl {
  border-radius: 28px !important;
  -webkit-border-radius: 28px !important;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl button {
  width: 48px !important;
  height: 48px !important;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl button.mapboxgl-ctrl-geolocate .mapboxgl-ctrl-icon {
  background-size: 30px 30px;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl-group:not(:empty) {
  box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
}
.mapbox-map ::ng-deep .mapboxgl-ctrl button:not(:disabled):hover {
  background-color: unset;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl-bottom-right {
  bottom: calc(52px + var(--yf-system-bottom-safe-area) + 8px) !important;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl-bottom-left {
  left: 12px !important;
  right: auto !important;
  bottom: calc(50px + var(--yf-system-bottom-safe-area) + 8px) !important;
}
.mapbox-map ::ng-deep .mapboxgl-ctrl-logo {
  width: 58px !important;
  height: 15px !important;
  margin: 0 !important;
  background-size: 58px 15px !important;
  opacity: 0.72;
}
:host-context(.plt-android) .mapbox-map {
  --yf-android-navigation-bottom-space: clamp(32px, 4vh, 56px);
}
/*# sourceMappingURL=map.component.css.map */
